<script>
import Layout from '../../../layout/Layout.vue'
import DefaultMixin from '../../mixin'
import ConsoleMenuItem from "components/fenaju/components/MenuItem.vue"
import {UInput} from 'uloc-vue'

export default {
  name: 'FenajuPage',
  mixins: [DefaultMixin],
  components: {
    Layout,
    ConsoleMenuItem,
    UInput
  },
  data () {
    return {
      busca: null,
      menu: [
        {name: 'dashboard', label: 'Dashboard', icon: 'fa-duotone fa-headset', route: 'fenaju.suporte'},
        {name: 'registro', label: 'Registro', icon: 'fa-duotone fa-id-card', route: 'fenaju.registros.lista'},
        {name: 'leiloeiros', label: 'Leiloeiros', icon: 'fa-duotone fa-person', route: 'fenaju.leiloeiros'},
        {name: 'tradutores', label: 'Tradutores', icon: 'fa-duotone fa-language', route: 'fenaju.tradutores.lista'},
        {name: 'tarefas', label: 'Tarefas', icon: 'fa-duotone fa-list-check', route: 'fenaju.tarefas'},
        // {name: 'tickets', label: 'Tickets', icon: 'fa-duotone fa-ticket', route: 'fenaju.tickets'},
        {name: 'financeiro', label: 'Financeiro', icon: 'fa-duotone fa-money-check', route: 'fenaju.financeiro'},
        {name: 'relatorios', label: 'Relatórios', icon: 'fa-duotone fa-chart-user', route: 'fenaju.infra', disabled: true},
      ],
    }
  },
  computed: {
  },
  mounted () {
    window.setTimeout(() => {
      this.erplayout.erpheader.setMenuModuleToggle(true)
    }, 400)
    document.body.classList.add('fenaju-module-body')
  },
  beforeDestroy () {
    this.erplayout.erpheader.setMenuModuleToggle(false)
    document.body.classList.remove('fenaju-module-body')
  },
  destroyed () {
  },
  methods: {
  },
  meta: {
    title: 'Console',
    name: 'Console'
  }
}
</script>

<template>
  <layout class="console-layout" no-menu no-title hfull>
    <div class="ev2-menu w-menub">
      <div class="content">
<!--        <div style="margin-right: 70px">
          <img src="@/assets/images/logo-black.png" style="width: 60px" />
        </div>-->
        <div class="tab">
          <div class="title">Operador ID</div>
          <div class="val">{{$uloc.auth.session.user.id}}</div>
        </div>
        <div class="tab">
          <div class="title">Operador</div>
          <div class="val">{{$uloc.auth.session.user.name}}</div>
        </div>
        <div class="tab">
          <div class="title">Instituição</div>
          <div class="val">FENAJU</div>
        </div>
        <div class="tab" v-if="$uloc.auth.session && $uloc.auth.session.user.papeis && $uloc.auth.session.user.papeis.worker && $uloc.auth.session.user.papeis.worker.office">
          <div class="title">
            Papel
            <i class="fal fa-circle-question">
              <u-tooltip :offset="[5,5]">Cargo atual</u-tooltip>
            </i>
          </div>
          <div class="val">{{$uloc.auth.session.user.papeis.worker.office.name}}</div>
        </div>
        <!--<div class="tab">
          <div class="title">Tarefas</div>
          <div class="val">0</div>
        </div>
        <div class="tab">
          <div class="title">Tarefas Atrasadas</div>
          <div class="val">0</div>
        </div>
        <div class="tab">
          <div class="title">Bônus</div>
          <div class="val">R$ 0,00 <small class="font-10">(em breve)</small></div>
        </div>-->
        <div class="tab full text-right">
          <div style="width: 300px; display: inline-flex" class="hide">
            <u-input v-model="busca" hide-underline inverted-light class="sl-grey-input full-width" placeholder="Pesquisar" :before="[{icon: 'search', handler () {}}]" />
          </div>
        </div>
      </div>
      <div class="menu-bottom content-menu">
        <console-menu-item
            v-for="m in menu"
            :key="m.name"
            :name="m.name"
            :icon="m.icon"
            :label="m.label"
            :route="m.route"
            :disabled="m.disabled"
        />
      </div>
    </div>
    <router-view />
  </layout>
</template>

<style lang="stylus" src="../../assets/default.styl"></style>
